import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
// import menutree from './menutree.json';
import menuStore from "common/menu/store/MenuStore";
export type BreadcrumbProps = {
	gnbIdx? : number,
	lnbIdx? : number
}
function Breadcrumb(props: BreadcrumbProps, ref: any) {
	const {
		gnbIdx = 0,
		lnbIdx = 0,
		//...otherProps
	} = props;
	return (
		<ul className="fww-brd">
			<li><Link to="/main/">홈</Link></li>
			{menuStore.currentMenuInfoList.map((menuInfo) => (
				<li key={menuInfo.getMenuId()} className={"breadcrumb-item"}>
					{/*<Link to={menuInfo.getMenuPath()}>{menuInfo.getMenuNm()}</Link>*/}
					<a>{menuInfo.getMenuNm()}</a>
				</li>
			))}
		</ul>
	);	
}
export default forwardRef(Breadcrumb);